import React from "react";
import Icon from "../Icon";

export default (props) => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      d="M4 24h24a2 2 0 002-2V9a2 2 0 00-2-2h-4a2 2 0 01-1.6-.8l-1.8-2.4A2 2 0 0019 3h-6a2 2 0 00-1.6.8L9.6 6.2A2 2 0 018 7H4a2 2 0 00-2 2v13c0 1.1.9 2 2 2zm12-5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
      fill="none"
    />
  </Icon>
);
